<div class="text-icon-container">
    <mat-icon class="notranslate material-symbols-rounded" *ngIf="icon">{{ icon }}</mat-icon>
    <span *ngIf="text">{{ text }}</span>
</div>